export const floor = (num, places = 1) => Math.floor(num * places) / places

export const floorToHundredth = float => floor(float, 100)

export const ceil = (num, places = 1) => Math.ceil(num * places) / places
